import { useState } from 'react';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { AssetService } from '~/app/services/asset/asset.service';

const DEFAULT_PAGE_SIZE = 10;

export function assetIncidentsQueryKey(
  assetId: string,
  page: number,
  limit: number,
) {
  return ['assets', assetId, 'incidents', { page, limit }] as const;
}

export function useAssetDetailIncidents(
  organizationId: string,
  assetId: string,
) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  const incidentsQuery = useQuery({
    queryKey: assetIncidentsQueryKey(assetId, page, pageSize),
    queryFn: () =>
      AssetService.listIncidentsByAssetId(organizationId, assetId, {
        page,
        limit: pageSize,
      }),
    enabled: !!assetId && !!organizationId,
    placeholderData: keepPreviousData,
  });

  return {
    incidents: incidentsQuery.data?.data ?? [],
    meta: incidentsQuery.data?.meta ?? {
      total: 0,
      page,
      limit: pageSize,
      totalPages: 0,
      openCount: 0,
      highPriorityCount: 0,
      latestCreatedAt: null,
    },
    isLoading: incidentsQuery.isLoading,
    isFetching: incidentsQuery.isFetching,
    error: incidentsQuery.error,
    refetch: incidentsQuery.refetch,
    page,
    pageSize,
    setPage,
    setPageSize: (next: number) => {
      setPageSize(next);
      setPage(1);
    },
  };
}
